import { useAttrs } from 'vue'

export default function useHasAttr() {
  const attrs = useAttrs()

  const hasAttr = (key: string, isBoolean = false) => {
    if (!isBoolean) {
      return key in attrs
    }

    if (!(key in attrs)) {
      return false
    }

    const type = typeof attrs[key]

    if (type === 'boolean') {
      return !!attrs[key]
    } else {
      return attrs[key] !== 'false'
    }
  }

  return hasAttr
}
